import React from 'react';
import type { ContentGroup } from '../types/curriculum';
interface ContentGroupsProps {
  groups: ContentGroup[];
}
export function ContentGroups({
  groups
}: ContentGroupsProps) {
  return <div className="space-y-5" data-id="element-128" data-mp="24iyfgoebis8f">
      {groups.map((group, groupIndex) => <div key={group.heading ?? groupIndex} data-id="element-129" data-mp="29a6ovkfnedll" data-mpi={groupIndex}>
          {group.heading && <h4 className="font-semibold text-teal-700 mb-2" data-id="element-130" data-mp="29cb24szfsoyj">
              {group.heading}
            </h4>}
          <ul className="space-y-2" data-id="element-131" data-mp="2j8e3vxqdmlky">
            {group.items.map(item => <li key={item} className="flex items-start gap-3" data-id="element-132" data-mp="2jah1p3xrtj08">
                <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-teal-500 flex-shrink-0" data-id="element-133" data-mp="2o8se9mfga7m5" />
                <span data-id="element-134" data-mp="2s8178p2o21gn">{item}</span>
              </li>)}
          </ul>
        </div>)}
    </div>;
}